import React from "react";

import styles from "./ImageTag.module.scss";

const ImageTag = ({ htmlData = "", image = "" }) => {
  if(!htmlData && !image) return null;
  
  return (
    <div className={styles.container}>
      <img src={image} alt="Amity Online" title="Amity Online"></img> 
      <div dangerouslySetInnerHTML={{ __html: htmlData }} />
    </div>
  );
};

export default ImageTag;
